exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loginDiv[data-v-00c0d336]{width:560px;position:absolute;left:50%;top:40%;transform:translateX(-50%) translateY(-60%);border:1px solid #ddd;border-radius:5px}.inputBlock[data-v-00c0d336]{margin:30px 50px 30px 30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-00c0d336","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Login.vue
// module id = 139
// module chunks = 0